import interceptor from '../restServiceInterceptor';
import {DepositTurnover} from '../models/deposit-turnover-models';
import {CashOrderReport, CashOrderReportFilters, CashOrderReportType, DepositDirectoryOption} from '../models/cash-order-report';

export const getDepositTurnover = (afterDate: string, beforeDate: string, assigneeId?: string): Promise<DepositTurnover> =>
    interceptor.get('/client-service/api/user/turnover/deposits', {params: {afterDate, beforeDate, assigneeId}});

const reportUrl = '/client-service/api/v1/device-deposits/cash-orders/report';

export const getCashOrderReport = (filters: CashOrderReportFilters, type: CashOrderReportType, page = 0, size = 50): Promise<CashOrderReport> =>
    interceptor.get(reportUrl, {params: {...filters, type, page, size}});

export const getDepositClients = (distributorId?: number): Promise<DepositDirectoryOption[]> =>
    interceptor.get(`${reportUrl}/clients`, {params: {distributorId}});

export const getDepositBranches = (clientId: number, distributorId?: number): Promise<DepositDirectoryOption[]> =>
    interceptor.get(`${reportUrl}/branches`, {params: {clientId, distributorId}});

export const getAllCashOrderReportRows = async (filters: CashOrderReportFilters, type: CashOrderReportType) => {
    const first = await getCashOrderReport(filters, type, 0, 500);
    const rows = [...first.items];
    for (let page = 1; page * 500 < first.totalElements; page++) {
        rows.push(...(await getCashOrderReport(filters, type, page, 500)).items);
    }
    return {rows, totals: first.totals};
};
